import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import typographyStyle from "assets/jss/material-dashboard-pro-react/components/typographyStyle.jsx";

function Gray({ ...props }) {
  const { classes, children } = props;
  return (
    <div className={classes.defaultFontStyle + " " + classes.grayText}>
      {children}
    </div>
  );
}

Gray.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(typographyStyle)(Gray);
